<template>
  <div v-if="items.length || error" class="mb-3" aria-label="Incomplete operator provisioning">
    <b-alert v-if="error" show variant="danger">{{ error }}
      <b-button size="sm" variant="outline-danger" @click="load">Retry</b-button>
    </b-alert>
    <b-alert v-for="item in items" :key="item.operationId" show variant="warning">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="operation-details mr-2">
          <strong>{{ item.name }}: provisioning incomplete</strong><br>
          <code>{{ item.operationId }}</code>
        </div>
        <b-button size="sm" variant="warning" :disabled="!!busy" @click="resume(item.operationId)">
          <b-spinner v-if="busy === item.operationId" small />
          <i v-else class="fas fa-redo" aria-hidden="true" /> Resume
        </b-button>
      </div>
    </b-alert>
  </div>
</template>

<script>
export default {
  data: () => ({ items: [], error: '', busy: null }),
  mounted() { this.load(); },
  methods: {
    async load() {
      try {
        this.items = (await this.$http.get('/api/v1/operators/template-operations/incomplete')).data.items;
        this.error = '';
      } catch (error) {
        this.error = 'Unable to load incomplete operator operations.';
      }
    },
    async resume(key) {
      if (this.busy) return;
      this.busy = key;
      this.error = '';
      try {
        await this.$http.post(`/api/v1/operators/template-operations/${key}/resume`);
        this.$emit('finish');
        await this.load();
      } catch (error) {
        this.error = (error.response && error.response.data.message) || 'Provisioning is still incomplete. Retry when the service is available.';
      } finally {
        this.busy = null;
      }
    },
  },
};
</script>

<style scoped>
.operation-details { min-width: 0; overflow-wrap: anywhere; }
</style>
